import React, { ReactElement } from 'react'
import { API_URL } from '@/utils/constants'
import useSWRImmutable from 'swr/immutable'
import { fetcher } from '@/utils/fetcher'
import InscriptionContent from '@/components/inscription-content'

const BRC420 = (props: any): ReactElement<{ id: string; className?: string }> => {
	const { id } = props
	const { data } = useSWRImmutable(`${API_URL}/inscription/${id}`, fetcher)

	if (!data) {
		return <React.Fragment />
	}

	return <InscriptionContent inscription={data} className={props.className} />
}

export default BRC420
